var exports = {
  "k": "x112a1f60--37aba3--container",
};

module.exports = exports;
